import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FileUploadSourceType } from 'src/app/shared/enum-value';
import { AcqnDashboardDetails } from 'src/app/model/AcquisitionDetails';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { Utils } from 'src/app/shared/utils';
import { LaunchDarklyUtil } from 'src/app/shared/launch-darkly-util';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';

@Component({
  standalone: false,
  selector: 'app-action-required',
  templateUrl: './action-required.component.html',
  styleUrls: ['./action-required.component.css']
})
export class ActionRequiredComponent implements OnInit {

  @Input() set lenderActionRequired(_lenderActionRequired: AcqnDashboardDetails[]) {
    if (_lenderActionRequired) {
      this.data = [];

      for (const item of _lenderActionRequired) {
        this.data.push({
          propertyName: item.propNme,
          pastDue: this.isPastDue(item.reqdSubmtDt),
          requiredSubmittedDate: this.utils.getFormattedDate(item.reqdSubmtDt),
          lastSubmittedDate: this.utils.getFormattedDate(item.maxSubmtDt),
          dusGatewayDealAndID: item.dlNme + ' (' + item.dusDealId + ')',
          estimatedAcquisitionDate: this.utils.getFormattedDate(item.aqsnDt),
          collateralReferenceNumber: item.coltRefNo,
          pca: item.pca,
          esa: item.esa,
          sra: item.sra,
          zon: item.zon,
          appr: item.appr,
          acquisitionDealId: item.aqsnDealId,
          propertyMasterNumber: item.propMstrNo,
          transType: item.transType,
          ssn: item.ssn,
          propId: item.propMstrNo,
          cmmtNo: item.cmmtNo
        });
      }
    }
  }

  @Output() propertyFileUploadDetails: EventEmitter<object> = new EventEmitter<object>();

  data: any = [];
  showUploadFiles = false;

  constructor(private router: Router,
    private apiService: ApiService,
    private utils: Utils, private fileUploadService: FileUploadService, private launchDarkly: LaunchDarklyUtil) { }

  ngOnInit(): void {

  }

  isPastDue(reqDate) {
    if (!reqDate)
      return false;

    var today = new Date();

    if (reqDate < today) {
      return true;
    } else if (reqDate > today) {
      return false;
    } else {
      return false;
    }
  }

  getUploadFilesDialogStatus(flag: boolean) {
    this.showUploadFiles = flag;
  }

  showUploadFilesDialog(flag: boolean, propertyName: string, dusGatewayDealAndID: string, collateralReferenceNumber: string, acquisitionDealId: string, propertyMasterNumber: string, transType: string, ssn: string, propId: string, cmmtNo: string) {
    //Launch Darkly
    this.launchDarkly.getLaunchDarklyShutDown(this, this.launchDarklyCallback)

    let selectedPropertyName = propertyName;
    let selectedDusDealId = dusGatewayDealAndID.match(/\(([^)]+)\)$/)[1];
    let selectedColtRefNo = collateralReferenceNumber;
    let selectedAqsnDealId = acquisitionDealId;
    let selectedPropertyMasterNumber = propertyMasterNumber;
    let selectedTransType = transType;
    let selectedSSN = ssn;
    let selectedPropId = propId;
    let selectedCmmtNo = cmmtNo;
    this.propertyFileUploadDetails.emit({ selectedPropertyName, selectedDusDealId, selectedColtRefNo, selectedAqsnDealId, selectedPropertyMasterNumber, selectedTransType, selectedSSN, selectedPropId, selectedCmmtNo });
    this.showUploadFiles = flag;

    this.fileUploadService.setSource(FileUploadSourceType.ActionRequired);
  }

  launchDarklyCallback(systemDownFlagValue: boolean, caller) {
    caller.systemDownFlagValue = systemDownFlagValue;
    console.log('LaunchDarkly flag systemDownFlagValue = ', caller.systemDownFlagValue);
    if (Object.keys(caller.systemDownFlagValue).length > 0) {
      // caller.apiService.systemDownFlagValue = caller.systemDownFlagValue;
      caller.menu = [];
      caller.showSystemDown = true;
      caller.showDueDiligenceDashboard = false;
      caller.unauthorizedUser = false;

      caller.apiService.shutDownApp = true;
      caller.router.navigate([''], { skipLocationChange: true });
    }
  }
}
